import { useSelector } from 'react-redux';
import { useSearchParams } from 'react-router';
import type { RootState } from '~/redux/store';

/**
 * The shipping location a "Compare" deep link from buyer inventory points at, or
 * null when the buyer didn't arrive that way, or undefined while the buyer's
 * locations are still loading and a deep link can't yet be confirmed valid.
 * Read during render, because Redux still holds the location the buyer last
 * browsed until the seeding effect runs — a query keyed off Redux alone fetches
 * under that stale location first.
 */
export function useDeepLinkedLocationId(): string | null | undefined {
  const [searchParams] = useSearchParams();
  const locationId = searchParams.get('locationId');
  const returnPath = searchParams.get('returnPath');
  const locations = useSelector(
    (state: RootState) => state.auth.user?.locations
  );

  if (returnPath !== '/buyer-inventory' || !locationId) return null;
  if (!locations) return undefined;
  return locations.some((l) => l.id === locationId) ? locationId : null;
}
